export default "__VITE_ASSET__CkUc9RzN__"